import * as Models from "../Models";
import * as _ from "lodash";
import * as lscache from "lscache";
import { ISelectColumn } from "../Components/General/ItemGroup/SelectColumns";

const WEEK_IN_MINUTES: number = 60 * 24 * 7;

export const localStorageSupported: boolean =
  "localStorage" in window && window.localStorage !== null;

export const shouldCardCollapse: Function = (cardName: string) => {
  if (!lscache.supported()) {
    return false;
  }

  const oldCards: string[] = lscache.get("collapsedCards");

  if (oldCards === null) {
    return false;
  }

  const cards: string[] = oldCards;

  return cards.indexOf(cardName) !== -1;
};

export const toggleCardShouldCollapse: Function = (cardName: string) => {
  if (!lscache.supported()) {
    return false;
  }

  let cards: Array<string> = [];
  const oldCards: string[] = lscache.get("collapsedCards");

  if (oldCards !== null) {
    const oldCardsArray: string[] = oldCards;

    cards = cards.concat(oldCardsArray);

    if (cards.indexOf(cardName) === -1) {
      cards.push(cardName);
    } else {
      cards = cards.filter((c) => c !== cardName);
    }
  }

  lscache.set("collapsedCards", cards);

  return true;
};

export const getAdvancedSearchColumnState: Function = (
  column: Models.SearchResultColumn
) => {
  if (!lscache.supported() || column.classAttribute) {
    return column;
  }

  const activeColumns: Models.SearchResultColumn[] = lscache.get("columns");

  if (activeColumns === null) {
    return column;
  }

  const columns: Models.SearchResultColumn[] = activeColumns;

  const foundColumn: Models.SearchResultColumn = _.find(
    columns,
    (c) => c.displayName === column.displayName
  );

  if (foundColumn) {
    return foundColumn;
  }

  return column;
};

export const setAdvancedSearchColumnState: Function = (
  column: Models.SearchResultColumn
) => {
  if (!lscache.supported()) {
    return column;
  }

  let columns: Models.SearchResultColumn[] = [];
  const activeColumns: Models.SearchResultColumn[] = lscache.get("columns");

  if (activeColumns !== null) {
    const columnsArray: Models.SearchResultColumn[] = activeColumns;

    columns = columns.concat(columnsArray);

    const foundColumn: Models.SearchResultColumn = _.find(
      columns,
      (c) => c.displayName === column.displayName
    );

    if (foundColumn) {
      columns = _.filter(columns, (c) => c.displayName !== column.displayName);
    } else {
      columns.push(column);
    }
  }

  lscache.set("columns", columns, WEEK_IN_MINUTES);

  return column;
};

export const getSiteAssetsColumnState: Function = (
  column: ISelectColumn
): ISelectColumn => {
  if (!lscache.supported()) {
    return column;
  }

  const activeColumns: ISelectColumn[] = lscache.get("siteassetscolumns");

  if (activeColumns === null) {
    return column;
  }

  const columns: ISelectColumn[] = activeColumns;

  const foundColumn: ISelectColumn = _.find(
    columns,
    (c) => c.value === column.value
  );

  if (foundColumn) {
    return foundColumn;
  }

  return column;
};

export const setSiteAssetsColumnState: Function = (
  column: ISelectColumn
): ISelectColumn => {
  if (!lscache.supported()) {
    return column;
  }

  let columns: ISelectColumn[] = [];
  const activeColumns: ISelectColumn[] = lscache.get("siteassetscolumns");

  if (activeColumns !== null) {
    const columnsArray: ISelectColumn[] = activeColumns;

    columns = columns.concat(columnsArray);

    const foundColumn: ISelectColumn = _.find(
      columns,
      (c) => c.value === column.value
    );

    if (foundColumn) {
      columns = _.filter(columns, (c) => c.value !== column.value);
    } else {
      columns.push(column);
    }
  }

  lscache.set("siteassetscolumns", columns, WEEK_IN_MINUTES);

  return column;
};
